import { createQueryKey } from 'src/utils/query/createQueryKey';

export const WALLET_BALANCES_QUERY_KEY = createQueryKey('walletBalances');
